import React from 'react'
import { Link } from 'react-router-dom';
import useAuth from '../../hooks/useAuth';

function Footer() {
    // const [Visible, setVisible] = useState(false)
    // const [loader, setLoader] = useState(1);
    const { auth } = useAuth();

    // const handleScroll = () => {
    //     var scrollTop =
    //         (document.documentElement && document.documentElement.scrollTop) ||
    //         document.body.scrollTop;
    //     if (scrollTop > 100) {
    //         // setVisible(true);
    //     } else {
    //         // setVisible(false);
    //     }
    // };
    // useEffect(() => {
    //     window.addEventListener('scroll', handleScroll);
    //     return () => {
    //         window.removeEventListener('scroll', handleScroll);
    //     };
    // }, []);

    // useEffect(() => {
    //     if (loader === 1) {
    //         setTimeout(() => setLoader(false), 2000);
    //     }
    // }, [loader]);

    // const gototop = () => {
    //     window.scrollTo({ top: 0, behavior: "smooth" })
    // }
    return (
        <>
            <footer>
                <div className="container">
                    <div className="row">
                        <div className="col-12 col-lg-5 col-xl-4 me-auto mb-5 mb-lg-0">
                            <Link
                                className="footer-logo h2 text-primary mb-0 font-w-7"
                                to="/"
                            >
                                <span className="text-dark font-w-4">inspectiver</span>
                            </Link>
                            <p className="my-3">
                                Inspectiver - Pre purchase car inspection
                            </p>
                            <ul className="list-inline">
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow Inspectiver on Facebook" to="https://www.facebook.com/inspectiver" target='_blank'
                                    ><i className="la la-facebook"></i></Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow Inspectiver on Instagram"v to="https://www.instagram.com/inspectiver" target='_blank'
                                    ><i className="la la-instagram"></i></Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow Inspectiver on X" to="https://www.x.com/inspectiver" target='_blank'
                                    ><i className="la la-twitter"></i></Link>
                                </li>
                                <li className="list-inline-item">
                                    <Link className="border rounded px-2 py-1 text-dark" aria-label="Follow Inspectiver on Linkedin" to="https://www.linkedin.com/company/inspectiver" target='_blank'
                                    ><i className="la la-linkedin"></i></Link>
                                </li>
                            </ul>
                        </div>
                        <div className="col-12 col-lg-6 col-xl-7">
                            <div className="row">
                                <div className="col-12 col-sm-4 navbar-light">
                                    <div className='mb-2 border-bottom'>
                                        <h6>Pages</h6>
                                    </div>
                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-3">
                                            <Link className="list-group-item-action" to="/about-us"
                                            >About Us</Link>
                                        </li>
                                        {!auth.user &&
                                            <li className="mb-3">
                                                <Link className="list-group-item-action" to="/faqs">FAQs</Link>
                                            </li>
                                        }
                                        <li className="mb-3">
                                            <Link className="list-group-item-action" to="/contact"
                                            >Contact Us</Link>
                                        </li>
                                        {!auth.user &&
                                            <li>
                                                <Link className="list-group-item-action" to="/inspector"
                                                ><strong>Become an Inspector</strong></Link>
                                            </li>
                                        }

                                    </ul>
                                </div>
                                <div className='col-12 col-sm-4 mt-3 mt-md-0'>
                                    <div className='mb-2 border-bottom'>
                                        <h6>Contact Us</h6>
                                    </div>

                                    <ul className="list-unstyled mb-0">
                                        <li className="mb-3">

                                            <span className="text-black">145 W Broadway, Long Beach, CA, 90802</span>
                                        </li>
                                        <li className="mb-3">
                                            <a className="btn-link" href="tel:+15624855485">(562) 485-5485</a>
                                        </li>
                                        <li className='mb-3' >
                                            <a className="btn-link"  href="mailto:support@inspectiver.com"> support@inspectiver.com</a>
                                        </li>
                                    </ul>

                                </div>
                                <div className="col-12 col-sm-4 mt-3 mt-md-0 navbar-light">
                                    <div className='mb-4 border-bottom'><h6>Inspector App</h6></div>
                                    <div className='col-8'>
                                        <a href="https://apps.apple.com/us/app/inspectiver-inspector/id6743119352" target="_blank" rel="noopener noreferrer">
                                            <img
                                                className="card-img-top"
                                                src={require(`../../assets/icon/appstore.webp`)}
                                                alt="Inspector"
                                                loading='lazy'
                                            />
                                        </a>

                                    </div>
                                    <div className='col-8 mt-2'>
                                        <a href="https://play.google.com/store/apps/details?id=com.inspectiver.inspector" target="_blank" rel="noopener noreferrer">
                                            <img
                                                className="card-img-top"
                                                src={require(`../../assets/icon/googleplay.webp`)}
                                                alt="Inspector"
                                                loading='lazy'
                                            />
                                        </a>
                                    </div>

                                </div>
                                <div className="col-12 col-sm-4 mt-6 mt-sm-0 navbar-light">


                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="row my-5">
                        <div className="col">
                            <hr className="m-0" />
                        </div>
                    </div>
                    <div className="row align-items-center mb-5">
                        <div className="col-md-6">
                            Copyright ©2025 All rights reserved | Inspectiver
                        </div>
                        <div className="col-md-6 text-md-end mt-3 mt-md-0">
                            <ul className="list-inline mb-0">

                                <li className="me-3 list-inline-item">
                                    <Link className="list-group-item-action" to="/privacy-policy">
                                        Privacy Policy
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </div>
                </div>
            </footer>
            {/* <div className={`${Visible ? 'scroll-top' : ''}`} >
                <div class="smoothscroll" onClick={gototop}>Scroll Top</div>
            </div> */}
        </>
    )
}

export default Footer
